import React, { useEffect } from 'react'
import Helmet from 'react-helmet'
import { useIntl } from 'react-intl'
import DashboardPanel from 'components/DashboardPanel/DashboardPanel'
import Layout from 'components/Layout/Layout'
import { useMobileContext } from 'context/MobileContext'

const Dashboard = () => {
  const title = useIntl().formatMessage({ id: 'Dashboard.title' }, { 0: process.env.REACT_APP_PAGE_TITLE })
  const { setShowBackButton } = useMobileContext()

  useEffect(() => {
    setShowBackButton(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Layout>
        <DashboardPanel />
      </Layout>
    </>
  )
}

export default Dashboard
